"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(blogs) {
  return blogs.size ? blogs.first().get('id') : null;
};

exports.default = _default;
module.exports = exports.default;